module.exports = __webpack_public_path__ + "6af4972f682a75cc6824b0b03b7fb18d.svg";